import { SegmentedControl } from '@mantine/core';
import { MantineForm } from '../AddEditMatterForm';
import styles from './FeeTypeSegmentedControl.module.css';
import { colorsForMatterType } from '@/utils/colorForMatterType';
import { InsuranceProvider } from '@shared/types';
import { getInputPropsSafe } from '@/utils/getInputPropsSafe';
import { InsuranceFormData } from '../types';
import { SelectOption } from '../../types';
import { colorsForForm } from '../colorsForForm';

const providerOptions: SelectOption<InsuranceProvider>[] = [
  { value: 'arag', label: 'ARAG' },
  { value: 'metlife', label: 'MetLife' },
  { value: 'legalease', label: 'LegalEase' },
  { value: 'other', label: 'Other' },
];

const InsuranceProviderSegmentedControl = ({
  mantineForm,
}: {
  mantineForm: MantineForm;
}) => {
  const values = mantineForm.getValues();
  if (values.feeType !== 'Insurance') {
    return null;
  }

  const colors = colorsForForm(mantineForm);

  return (
    <SegmentedControl
      radius='20px'
      classNames={styles}
      style={
        {
          '--active-text-color': colors.foreground,
          '--active-bg-color': colors.background,
        } as React.CSSProperties
      }
      fullWidth
      data={providerOptions}
      value={
        (mantineForm.getValues() as InsuranceFormData).insuranceProvider ?? ''
      }
      onChange={(value) => {
        mantineForm.setValues({
          insuranceProvider: value as InsuranceProvider,
        });
      }}
    />
  );
};

export default InsuranceProviderSegmentedControl;
